export const TIMELINE_PX_OFFSET = 20;
export const TIMELINE_BAR_HEIGHT_THRESHOLD = 30;
export const DURATION_FORMAT = 'h[h] mm[m]';
export const HOUR_EDITOR_DURATION_FORMAT = "h'h' m'm'";

export const DEFAULT_MEMORY_RETENTION_DAYS = 90;
export const MIN_MEMORY_RETENTION_DAYS = 14;
export const MAX_MEMORY_RETENTION_DAYS = 365;
